import React, {PureComponent} from 'react';


class Audi extends PureComponent {
  render() {
    const {width='50px', fill1='#181919', fill2='#343332'} = this.props;

    return (
        <svg id="Layer_2"  x="0px" y="0px" width={width} viewBox="0 0 174 64" style={{enableBackground:"new 0 0 174 64"}}>
            <g>
                <path fill={fill1} d="M172.4,32c0,16.7-13.6,30.3-30.3,30.3c-1.1,0-2.2-0.1-3.3-0.2c15.2-1.6,27-14.5,27-30.1
                    c0-15.6-11.8-28.5-27-30.1c1.1-0.1,2.2-0.2,3.3-0.2C158.8,1.7,172.4,15.3,172.4,32z"/>
                <path fill={fill2} d="M138.8,1.9c-15.2,1.6-27,14.5-27,30.1c0,15.6,11.8,28.5,27,30.1c15.2-1.6,27-14.5,27-30.1
                    C165.8,16.4,154,3.5,138.8,1.9z M142.1,54c-12.1,0-22-9.8-22-22c0-12.1,9.8-22,22-22c12.1,0,22,9.8,22,22
                    C164,44.1,154.2,54,142.1,54z"/>
                <path fill={fill1} d="M135.7,32c0,16.7-13.6,30.3-30.3,30.3c-1.1,0-2.2-0.1-3.3-0.2c15.2-1.6,27-14.5,27-30.1
                    c0-15.6-11.8-28.5-27-30.1c1.1-0.1,2.2-0.2,3.3-0.2C122.1,1.7,135.7,15.3,135.7,32z"/>
                <path fill={fill2} d="M102.1,1.9c-15.2,1.6-27,14.5-27,30.1c0,15.6,11.8,28.5,27,30.1c15.2-1.6,27-14.5,27-30.1
                    C129.1,16.4,117.3,3.5,102.1,1.9z M105.4,54c-12.1,0-22-9.8-22-22c0-12.1,9.8-22,22-22s22,9.8,22,22C127.3,44.1,117.5,54,105.4,54z
                    "/>
                <path fill={fill1} d="M98.4,32c0,16.7-13.6,30.3-30.3,30.3c-1.1,0-2.2-0.1-3.3-0.2c15.2-1.6,27-14.5,27-30.1
                    c0-15.6-11.8-28.5-27-30.1c1.1-0.1,2.2-0.2,3.3-0.2C84.8,1.7,98.4,15.3,98.4,32z"/>
                <path fill={fill2} d="M64.8,1.9c-15.2,1.6-27,14.5-27,30.1c0,15.6,11.8,28.5,27,30.1c15.2-1.6,27-14.5,27-30.1
                    C91.8,16.4,80,3.5,64.8,1.9z M68.1,54c-12.1,0-22-9.8-22-22c0-12.1,9.8-22,22-22s22,9.8,22,22C90.1,44.1,80.2,54,68.1,54z"/>
                <path fill={fill1} d="M62.2,32c0,16.7-13.6,30.3-30.3,30.3c-1.1,0-2.2-0.1-3.3-0.2c15.2-1.6,27-14.5,27-30.1
                    c0-15.6-11.8-28.5-27-30.1c1.1-0.1,2.2-0.2,3.3-0.2C48.7,1.7,62.2,15.3,62.2,32z"/>
                <path fill={fill2} d="M28.7,1.9C13.5,3.5,1.6,16.4,1.6,32c0,15.6,11.8,28.5,27,30.1c15.2-1.6,27-14.5,27-30.1
                    C55.7,16.4,43.9,3.5,28.7,1.9z M31.9,54c-12.1,0-22-9.8-22-22c0-12.1,9.8-22,22-22s22,9.8,22,22C53.9,44.1,44.1,54,31.9,54z"/>
            </g>
        </svg>
    );
  }
}

export default Audi;